"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var microsoftTeams = require("@microsoft/teams-js");
var data_1 = require("../../../constants/data");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_icons_northstar_1 = require("@fluentui/react-icons-northstar");
var LineNoAxes_1 = require("../../chart/Charts/LineNoAxes");
require("../visao-geral-atendimentos/visao-geral-atendimentos.scss");
var react_i18next_1 = require("react-i18next");
var i18n_1 = require("../../../i18n");
var loaderVisaoGeralAtendimentos_1 = require("../../loaders/loaderVisaoGeralAtendimentos");
var VisaoGeralAtendimentos = /** @class */ (function (_super) {
    __extends(VisaoGeralAtendimentos, _super);
    function VisaoGeralAtendimentos(props) {
        var _this = _super.call(this, props) || this;
        _this.parseMetrics = function (metricsData) {
            var metricsLabel = [];
            var solicitacoesAtendimento = [];
            var atendimentosRealizados = [];
            var totalSolicitacoesAtendimento = [];
            var totalAtendimentosRealizados = [];
            metricsData === null || metricsData === void 0 ? void 0 : metricsData.map(function (metric, index) {
                var month = data_1.default.monthNames[parseInt(metric.Day.substr(4, 2), 10) - 1];
                var day = metric.Day.substr(6, 2).replace(/^0+/, '');
                metricsLabel.push(month + " " + day);
                solicitacoesAtendimento.push(metric.SolicitacoesAtendimento);
                atendimentosRealizados.push(metric.AtendimentoRealizados);
                totalSolicitacoesAtendimento.push(metric.TotalSolicitacoesAtendimento);
                totalAtendimentosRealizados.push(metric.TotalAtendimentosRealizados);
            });
            return {
                label: metricsLabel,
                solicitacoesAtendimento: solicitacoesAtendimento,
                atendimentosRealizados: atendimentosRealizados,
                totalSolicitacoesAtendimento: totalSolicitacoesAtendimento,
                totalAtendimentosRealizados: totalAtendimentosRealizados,
            };
        };
        _this.onViewDetails = function () {
            var taskInfo = {
                url: window.location.origin + ("/detalhes-sumario-atendimentos?iniciados=" + _this.formatDataNumber(_this.props.metrics.total) + "&avg=" + _this.formatDataNumber(parseInt(_this.props.metrics.averages))),
                title: _this.localize("DetalhesSumario"),
                height: 400,
                width: 500,
                fallbackUrl: window.location.origin + ("/detalhes-sumario-atendimentos?iniciados=" + _this.formatDataNumber(_this.props.metrics.total) + "&avg=" + _this.formatDataNumber(parseInt(_this.props.metrics.averages))),
            };
            microsoftTeams.tasks.startTask(taskInfo);
        };
        _this.localize = _this.props.t;
        _this.state = {
            activeTabId: 0,
            metrics: _this.props.metrics,
            chartDataSolicitacoesAtendimentos: {
                labels: _this.parseMetrics(_this.props.metrics).label,
                datasets: [
                    {
                        data: _this.parseMetrics(_this.props.metrics).solicitacoesAtendimento,
                    },
                ],
            },
            chartDataAtendimentosRealizados: {
                labels: _this.parseMetrics(_this.props.metrics).label,
                datasets: [
                    {
                        data: _this.parseMetrics(_this.props.metrics).atendimentosRealizados,
                    },
                ],
            },
            loading: false,
        };
        return _this;
    }
    VisaoGeralAtendimentos.prototype.componentDidMount = function () {
        microsoftTeams.initialize();
    };
    VisaoGeralAtendimentos.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.metrics !== this.props.metrics) {
            this.setState({
                activeTabId: this.props.index,
                chartDataSolicitacoesAtendimentos: {
                    labels: this.parseMetrics(this.props.metrics).label,
                    datasets: [
                        {
                            data: this.parseMetrics(this.props.metrics).solicitacoesAtendimento,
                        },
                    ],
                },
                chartDataAtendimentosRealizados: {
                    labels: this.parseMetrics(this.props.metrics).label,
                    datasets: [
                        {
                            data: this.parseMetrics(this.props.metrics).atendimentosRealizados,
                        },
                    ],
                }
            });
        }
    };
    VisaoGeralAtendimentos.prototype.formatDataNumber = function (number) {
        if (number)
            return this.formatAbbreviatedNumber(number);
        else
            return 0;
    };
    VisaoGeralAtendimentos.prototype.formatAbbreviatedNumber = function (number) {
        if (i18n_1.default.language == "en-US") {
            if (number) {
                var numberFormat;
                if (number > 1000000) {
                    numberFormat = (number / 1000000).toFixed(1) + "M";
                }
                else if (number > 1000) {
                    numberFormat = (number / 1000).toFixed(1) + "k";
                }
                else {
                    numberFormat = new Intl.NumberFormat(i18n_1.default.language).format(number);
                }
                return numberFormat;
            }
            else {
                return 0;
            }
        }
        else {
            if (number) {
                var numberFormat;
                if (number > 1000000) {
                    numberFormat = (number / 1000000).toFixed(1) + "mi";
                }
                else if (number > 1000) {
                    numberFormat = (number / 1000).toFixed(1) + "mil";
                }
                else {
                    numberFormat = new Intl.NumberFormat(i18n_1.default.language).format(number);
                }
                return numberFormat;
            }
            else {
                return 0;
            }
        }
    };
    VisaoGeralAtendimentos.prototype.setActiveTabId = function (index, item) {
        var _this = this;
        var selected = isNaN(item.content.split(" ")[0]) ? 0 : parseInt(item.content.split(" ")[0]);
        this.props.filter(selected, index).then(function (res) { return _this.setState({ loading: false }); });
        this.setState({
            activeTabId: index
        });
    };
    VisaoGeralAtendimentos.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        return (React.createElement(react_northstar_1.Box, { className: "visao-geral-atendimentos", styles: {
                display: "grid",
                gridGap: ".5rem",
                gridTemplate: "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(28.75rem, 1fr))",
                gridAutoFlow: "dense",
                gridAutoRows: this.props.collapsed ? "15rem 2rem" : "26rem 2rem",
                padding: ".5rem",
                minWidth: "20rem",
                "@media (max-width: 986px)": {
                    gridTemplate: "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                },
            } },
            React.createElement(react_northstar_1.Card.Header, null,
                React.createElement(react_northstar_1.Flex, { gap: "gap.small", space: "between", style: { minHeight: "2rem" } },
                    React.createElement(react_northstar_1.Flex, { gap: "gap.small", column: true },
                        React.createElement(react_northstar_1.Text, { truncated: true, content: this.props.customTitle ? this.props.customTitle : this.localize("VisaoGeralAtendimentos"), style: { margin: 0 }, weight: "bold" })))),
            React.createElement(react_northstar_1.Card.Body, { style: {
                    marginBottom: "0.75rem",
                    height: "100%",
                    overflow: "hidden",
                }, fitted: true }, this.props.totalMetrics ?
                React.createElement(React.Fragment, null,
                    React.createElement(react_northstar_1.Menu, { hidden: this.props.collapsed, className: "tabList", style: {
                            border: "none",
                            background: "none",
                            marginBottom: "1.25rem",
                        }, items: [
                            {
                                key: "1",
                                content: this.localize("TabHoje")
                            },
                            {
                                key: "7",
                                content: this.localize("7dias")
                            },
                            {
                                key: "30",
                                content: this.localize("30dias")
                            },
                            {
                                key: "60",
                                content: this.localize("60dias")
                            }
                        ], activeIndex: this.props.index, onItemClick: function (currentTarget, props) {
                            _this.setState({ loading: true });
                            _this.setActiveTabId(props && props.index ? props.index : 0, props);
                        }, accessibility: react_northstar_1.tabListBehavior, underlined: true, primary: true }),
                    this.state.loading ? React.createElement(loaderVisaoGeralAtendimentos_1.default, null) :
                        React.createElement(react_northstar_1.Flex, { gap: "gap.smaller", column: true },
                            React.createElement(react_northstar_1.Flex, { gap: "gap.medium", className: "chartContainer" },
                                React.createElement(react_northstar_1.Flex, { className: "chartFlex" },
                                    React.createElement(react_northstar_1.ProviderConsumer, { render: function (globalTheme) {
                                            return (React.createElement(LineNoAxes_1.default, __assign({}, {
                                                title: _this.localize("VisaoGeralAtendimentos"),
                                                data: _this.state.chartDataSolicitacoesAtendimentos,
                                                siteVariables: globalTheme.siteVariables,
                                                customHeight: "75",
                                            })));
                                        } })),
                                React.createElement(react_northstar_1.Flex, { className: "chartLabel", column: true },
                                    React.createElement(react_northstar_1.Text, { size: "larger", content: this.formatDataNumber(this.parseMetrics(this.props.metrics).totalSolicitacoesAtendimento[0]) }),
                                    React.createElement(react_northstar_1.Text, { size: "smaller", content: this.localize("SolicitacoesAtendimento") }))),
                            React.createElement(react_northstar_1.Flex, { gap: "gap.medium", className: "chartContainer" },
                                React.createElement(react_northstar_1.Flex, { className: "chartFlex" },
                                    React.createElement(react_northstar_1.ProviderConsumer, { render: function (globalTheme) {
                                            return (React.createElement(LineNoAxes_1.default, __assign({}, {
                                                title: _this.localize("VisaoGeralAtendimentos"),
                                                data: _this.state.chartDataAtendimentosRealizados,
                                                siteVariables: globalTheme.siteVariables,
                                                customHeight: "75",
                                            })));
                                        } })),
                                React.createElement(react_northstar_1.Flex, { className: "chartLabel", column: true },
                                    React.createElement(react_northstar_1.Text, { size: "larger", content: this.formatDataNumber(this.parseMetrics(this.props.metrics).totalAtendimentosRealizados[0]) }),
                                    React.createElement(react_northstar_1.Text, { size: "smaller", content: this.localize("AtendimentosRealizados") }))),
                            React.createElement(react_northstar_1.Divider, { className: "adjust", hidden: this.props.collapsed }),
                            React.createElement(react_northstar_1.Flex, { hidden: this.props.collapsed, gap: "gap.large" },
                                React.createElement(react_northstar_1.Flex, { column: true, fill: true },
                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(react_northstar_1.Text, { size: "larger", content: this.formatDataNumber((_a = this.props.totalMetrics) === null || _a === void 0 ? void 0 : _a.totalSolicitacoes) }), content: new Intl.NumberFormat(i18n_1.default.language).format((_b = this.props.totalMetrics) === null || _b === void 0 ? void 0 : _b.totalSolicitacoes), position: "above", align: "start" }),
                                    React.createElement(react_northstar_1.Text, { size: "smaller", content: this.localize("TotalRegistradas") })),
                                React.createElement(react_northstar_1.Flex, { column: true, fill: true },
                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(react_northstar_1.Text, { size: "larger", content: this.formatDataNumber((_c = this.props.totalMetrics) === null || _c === void 0 ? void 0 : _c.totalAtendimentos) }), content: new Intl.NumberFormat(i18n_1.default.language).format((_d = this.props.totalMetrics) === null || _d === void 0 ? void 0 : _d.totalAtendimentos), position: "above", align: "start" }),
                                    React.createElement(react_northstar_1.Text, { size: "smaller", content: this.localize("TotalRealizados") })),
                                React.createElement(react_northstar_1.Flex, { column: true, fill: true },
                                    React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(react_northstar_1.Text, { size: "larger", content: this.formatDataNumber((_e = this.props.totalMetrics) === null || _e === void 0 ? void 0 : _e.totalAtendentesAtivos) }), content: new Intl.NumberFormat(i18n_1.default.language).format((_f = this.props.totalMetrics) === null || _f === void 0 ? void 0 : _f.totalAtendentesAtivos), position: "above", align: "start" }),
                                    React.createElement(react_northstar_1.Text, { size: "smaller", content: this.localize("TotalAtendentes") })))))
                :
                    React.createElement("svg", { className: "emptyChart", viewBox: "0 0 550 550" },
                        React.createElement("rect", { y: "37.7", width: "88.7", height: "414.6" }),
                        React.createElement("rect", { x: "133.8", y: "147.4", width: "88.7", height: "304.9" }),
                        React.createElement("rect", { x: "267.6", y: "235.7", width: "88.7", height: "216.6" }),
                        React.createElement("rect", { x: "401.3", y: "307.2", width: "88.7", height: "145.1" }))),
            React.createElement(react_northstar_1.Card.Footer, { fitted: true },
                React.createElement(react_northstar_1.Flex, { vAlign: "center", hAlign: "end" },
                    React.createElement(react_northstar_1.Text, { as: "a", href: "#", size: "small", color: "brand", styles: {
                            textDecoration: "none",
                        }, onClick: function () { return _this.props.collapseCharts(!_this.props.collapsed); } },
                        this.props.collapsed &&
                            React.createElement(React.Fragment, null,
                                "Ver mais",
                                React.createElement(react_icons_northstar_1.ArrowDownIcon, { size: "smaller", styles: { margin: "0 .6rem" } })),
                        !this.props.collapsed &&
                            React.createElement(React.Fragment, null,
                                "Ver menos",
                                React.createElement(react_icons_northstar_1.ArrowUpIcon, { size: "smaller", styles: { margin: "0 .6rem" } })))))));
    };
    return VisaoGeralAtendimentos;
}(React.Component));
var visaoGeralAtendimentosWithTranslation = react_i18next_1.withTranslation()(VisaoGeralAtendimentos);
exports.default = visaoGeralAtendimentosWithTranslation;
//# sourceMappingURL=visao-geral-atendimentos.js.map